import { DefectPriority } from "../../types/DefectPriority";
import { DefectStatus } from "../../types/DefectStatus";
import { DefectSummaryDataItem } from "../../types/DefectSummaryDataItem";
import { DefectSummaryActionMenu } from "./DefectSummaryActionMenu";
import { SharedDefectSummaryActionMenu } from "./SharedDefectSummaryActionMenu";
import { DefectSummaryInspectionSince } from "./DefectSummaryInspectionSince";
import { DefectSummaryPriorityLink } from "./DefectSummaryPriorityLink";
import { SharedDefectSummaryPriorityLink } from "./SharedDefectSummaryPriorityLink";
import { DefectSummaryStatusLink } from "./DefectSummaryStatusLink";
import { SharedDefectSummaryStatusLink } from "./SharedDefectSummaryStatusLink";
import { DefectSummaryTotalDefectsLink } from "./DefectSummaryTotalDefectsLink";
import { SharedDefectSummaryTotalDefectsLink } from "./SharedDefectSummaryTotalDefectsLink";

export const vesselNameTemplate = (rowData: DefectSummaryDataItem) => {
    return (
            <div className="justify-content-start">
                <div>
                    <p>{rowData.vesselName}</p>
                    <small>{rowData.imo}</small>
                </div>
            </div>
    );
}

export const vesselTypeBodyTemplate = (rowData: DefectSummaryDataItem) => {
    return (
        <div>
            <p>{rowData.vesselType}</p>
            <small>{rowData.subType}</small>
        </div>
    );
};

export const defectSummaryActionMenuTemplate = (rowData: DefectSummaryDataItem) => 
    <DefectSummaryActionMenu rowData={rowData} />

export const sharedDefectSummaryActionMenuTemplate = (rowData: DefectSummaryDataItem) => 
    <SharedDefectSummaryActionMenu rowData={rowData} />

export const defectSummaryTotalDefectsLinkTemplate = (rowData: DefectSummaryDataItem) => 
    <DefectSummaryTotalDefectsLink rowData={rowData} />

export const sharedDefectSummaryTotalDefectsLinkTemplate = (rowData: DefectSummaryDataItem) => 
    <SharedDefectSummaryTotalDefectsLink rowData={rowData} />

export const defectSummaryPriorityLinkTemplate = (priority: DefectPriority) => (rowData: DefectSummaryDataItem) =>
    <DefectSummaryPriorityLink rowData={rowData} priority={priority} />

export const sharedDefectSummaryPriorityLinkTemplate = (priority: DefectPriority) => (rowData: DefectSummaryDataItem) =>
    <SharedDefectSummaryPriorityLink rowData={rowData} priority={priority} />

export const defectSummaryStatusLinkTemplate = (status: DefectStatus) => (rowData: DefectSummaryDataItem) =>
    <DefectSummaryStatusLink rowData={rowData} status={status} />

export const sharedDefectSummaryStatusLinkTemplate = (status: DefectStatus) => (rowData: DefectSummaryDataItem) =>
    <SharedDefectSummaryStatusLink rowData={rowData} status={status} />

export const defectSummaryInspectionSinceTemplate = (rowData: DefectSummaryDataItem) =>
    <DefectSummaryInspectionSince rowData={rowData} />